/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class AutomationFinAiAgentAnalyzeMonitorEditScorecardAttributeRoute extends Route {
  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.analyze.monitor.edit-scorecard.attribute',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(AutomationFinAiAgentAnalyzeMonitorEditScorecardAttributeRoute);
